import { z } from 'zod'

export const PostAwsProvisionParser = z.object({
  id: z.number(),
  zixiServer: z.string().nullable(),
  backupZixiServer: z.string().nullable(),
  allocationCode: z.number(),
  backupProvisionFailed: z.boolean(),
  storeVodFile: z.boolean(),
  transcoderType: z.string(),
  live: z.boolean()
})

export type AwsProvision = z.infer<typeof PostAwsProvisionParser>
